import { Injectable } from "@angular/core"

/**
 * Classe com métodos genéricos
 */
@Injectable()
export class AppUtils {

  static replaceAll(str: any, find: any, replace: any) {

    return str.replace(new RegExp(find, "g"), replace)
  }

  static truncateString(str: any, maxLength: any) {

    str = str.trim()

    if (str.length > maxLength)
      str = str.substring(0, (maxLength - 3)) + "..."

    return str
  }

  static cloneObject(obj) {

    const json = JSON.stringify(obj)

    return JSON.parse(json)
  }
}



// WEBPACK FOOTER //
// ./src/services/app-utils.ts